import { atom, atomFamily, selector, selectorFamily } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";
import contentsPresetEffect from "./effect/ContentsPresetEffect";
import { disabledContentsWithID } from "./DisabledContentsState";
import { isEmpty } from "../utils/FPEUtils";

export const WX_ID_SIGMET ='WX_ID_SIGMET';
export const WX_ID_VAA ='WX_ID_VAA';
export const WX_ID_SIGWX ='WX_ID_SIGWX';
export const WX_ID_UKMET ='WX_ID_UKMET';
export const WX_ID_MSM = 'WX_ID_MSM';
export const WX_ID_LFM = 'WX_ID_LFM';
export const WX_ID_GSM = 'WX_ID_GSM';
export const WX_ID_GFS = 'WX_ID_GFS';
export const WX_ID_WNI_OCEAN_CURRENT = 'WX_ID_WNI_OCEAN_CURRENT';
export const WX_ID_SATELLITE ='WX_ID_SATELLITE';
export const WX_ID_HIMAWARI = 'WX_ID_HIMAWARI';
export const WX_ID_ASCSCALE ='WX_ID_ASCSCALE';
export const WX_ID_ACOS ='WX_ID_ACOS';
export const WX_ID_RADAR ='WX_ID_RADAR';
export const WX_ID_SURFACEANALYSIS ='WX_ID_SURFACEANALYSIS';
export const WX_ID_TROPICALCYCLONE ='WX_ID_TROPICALCYCLONE';
export const WX_ID_METARTAF ='WX_ID_METARTAF';
export const WX_ID_LIGHTNING = 'WX_ID_LIGHTNING';
export const WX_ID_AMEDAS ='WX_ID_AMEDAS';
export const WX_ID_SYNOP = 'WX_ID_SYNOP';
export const WX_ID_SST = 'WX_ID_SST';
export const WX_ID_LIVECAMERA = 'WX_ID_LIVECAMERA';
export const WX_ID_POTEKA ='WX_ID_POTEKA';
export const WX_ID_AMEYUKI ='WX_ID_AMEYUKI';
export const WX_ID_SS_SCALE = 'WX_ID_SS_SCALE';
export const WX_ID_GASS_SCALE = 'WX_ID_GASS_SCALE';
export const WX_ID_TIME_SCOPE_COMPOSITE_RADAR = 'WX_ID_TIME_SCOPE_COMPOSITE_RADAR';
export const WX_ID_SORACAMELIGHT = 'WX_ID_SORACAMELIGHT';

export const WX_SETTINGS = {
  [WX_ID_SIGMET] : {visible: false, crossSection: false, altitude: 'range'},
  [WX_ID_VAA] : {visible: false, crossSection: false, altitude: 'range'},
  [WX_ID_SIGWX] : {visible: false, crossSection: false, altitude: 'range'},
  [WX_ID_UKMET] : {visible: false, crossSection: true, altitude: 'individual'},
  [WX_ID_MSM] : {visible: false, crossSection: true, altitude: 'individual'},
  [WX_ID_LFM] : {visible: false, crossSection: true, altitude: 'individual'},
  [WX_ID_GSM] : {visible: false, crossSection: true, altitude: 'individual'},
  [WX_ID_GFS] : {visible: false, crossSection: true, altitude: 'individual'},
  [WX_ID_WNI_OCEAN_CURRENT] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_SATELLITE] : {visible: false, crossSection: true, altitude: false},
  [WX_ID_HIMAWARI] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_ASCSCALE] : {visible: false, crossSection: true, altitude: 'individual'},
  [WX_ID_ACOS] : {visible: false, crossSection: true, altitude: 'individual'},
  [WX_ID_RADAR] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_SURFACEANALYSIS] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_TROPICALCYCLONE] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_METARTAF] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_LIGHTNING] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_AMEDAS] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_SYNOP] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_SST] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_LIVECAMERA] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_POTEKA] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_AMEYUKI] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_SS_SCALE] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_GASS_SCALE] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_TIME_SCOPE_COMPOSITE_RADAR] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_SORACAMELIGHT] : {visible: false, crossSection: false, altitude: false},
}

export const isWXContents = (id) => {
  return Object.keys(WX_SETTINGS).includes(id);
}

const weatherVisibleFamily = atomFamily({
  key: 'weatherVisibleFamily',
  default: selectorFamily({
    key: 'weatherVisibleFamilySelector',
    get: param => ({get}) => {
      const state = get(disabledContentsWithID(param));
      const disabled = typeof state === 'boolean' ? state : Object.values(state).filter(v=>v).length === Object.keys(state).length;
      return disabled ? false : getCustomerSettings(`layerConfig.${param}.checked`);
    }
  }),
  effects: param => [
    contentsPresetEffect(param)
  ]
});

export const selectedWeatherList = atom({
  key: 'selectedWeatherList',
  default: selector({
    key: 'selectedWeatherListSelector',
    get: () => {
      const layerConfig = getCustomerSettings('layerConfig');
      const menuWeatherOrder = getCustomerSettings('menuWeatherOrder');
      const list = [];
      menuWeatherOrder.forEach(wx => {
        if(layerConfig[wx].checked) {
          list.push(wx);
        }
      });
      return list;
    }
  })
});

export const weatherVisibleWithID = selectorFamily({
  key: 'weatherVisibleWithID',

  get: (id) => ({get}) => {
    return get(weatherVisibleFamily(id));
  },

  set: (id) => ({set, get}, visible) => {
    set(weatherVisibleFamily(id), visible);
    const oldList = get(selectedWeatherList);
    let newList;
    if (visible) {
      if (oldList.includes(id)) {
        return;
      }
      newList = [...oldList, id];
    } else {
      newList = oldList.filter(_id => _id !== id);
    }
    set(selectedWeatherList, newList);
  }
});

export const toggleWeatherVisibleWithID = selectorFamily({
  key: 'toggleWeatherVisibleWithID',
  set: (id) => ({set, get}) => {
    const visible = get(weatherVisibleWithID(id))
    set(weatherVisibleWithID(id), !visible);
  }
});

export const weatherTimeWithID = atomFamily({
  key: 'weatherTimeWithID',
  default:{}
});

const weatherAutoRefreshFamily = atomFamily({
  key: 'weatherAutoRefreshFamily',
  default: true
});

export const weatherAutoRefreshWithID = selectorFamily({
  key: 'weatherAutoRefreshWithID',

  get: (id) => ({get}) => {
    return get(weatherAutoRefreshFamily(id));
  },

  set: (id) => ({set}, autoRefresh) => {
    set(weatherAutoRefreshFamily(id), autoRefresh);
  }
});

export const contentsTimeListSelector = selector({
  key: 'contentsTimeListSelector',
  get: ({get}) => {
    const selectedWxList = get(selectedWeatherList);
    return selectedWxList.filter(wxId => !isEmpty(get(weatherTimeWithID(wxId))));
  }
})

const weatherMissingFamily = atomFamily({
  key: 'weatherMissingFamily',
  default: {
    missing: false,
    expired: 0
  }
});

export const weatherMissingWithID = selectorFamily({
  key: 'weatherMissingWithID',

  get: (id) => ({get}) => {
    return get(weatherMissingFamily(id));
  },

  set: (id) => ({set, get}, visible) => {
    set(weatherMissingFamily(id), visible);
  }
});
